/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Surface_RealtimeInputs */

const en_marketing_surface_realtime = /** @type {(inputs: Marketing_Surface_RealtimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realtime`)
};

const es_marketing_surface_realtime = /** @type {(inputs: Marketing_Surface_RealtimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo real`)
};

const fr_marketing_surface_realtime = /** @type {(inputs: Marketing_Surface_RealtimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps réel`)
};

/**
* | output |
* | --- |
* | "Realtime" |
*
* @param {Marketing_Surface_RealtimeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_surface_realtime = /** @type {((inputs?: Marketing_Surface_RealtimeInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Surface_RealtimeInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_surface_realtime(inputs)
	if (locale === "es") return es_marketing_surface_realtime(inputs)
	return fr_marketing_surface_realtime(inputs)
});